import styled from 'styled-components';

/* The dashbar's theme control, sitting between the timer and + Create. The
   design gives it the same outlined treatment as the timer beside it — a 32px
   rounded square on a 1px rule with no fill (node 12:1309) — rather than the
   solid CTA or the round avatar at either end of the cluster.

   The Sun is stroked and the Moon is filled, so neither can be coloured from a
   single property; both draw in currentColor and take the bar's icon token
   from here. */
const SThemeToggle = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid ${props => props.theme.dashbar.borderColor};
  border-radius: 12px;
  background: transparent;
  color: ${props => props.theme.dashbar.iconColor};
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease,
    border-color 0.2s ease;

  &:hover:not(:disabled) {
    color: ${props => props.theme.dashbar.valueColor};
    border-color: ${props => props.theme.dashbar.iconColor};
  }

  &:disabled {
    cursor: default;
  }
`;

export default SThemeToggle;
